module.exports = __webpack_public_path__ + "static/media/denied.f1d3c782.png";